import { 
  PAGE_WIDTH,
  MARGIN_LEFT,
  MARGIN_RIGHT,
  MARGIN_Y,
  CONTENT_WIDTH,
  bottomMarginItemGlobal,
  lineHeightGlobal,
  INTEND_GLOBAL
} from "../../utils/pdfConstants";

import { normalizeSource } from "../../utils/normalizeSource";

export function renderPropertyInfoBlock({ block, content, rakennusData, mergedRakennusData, contentWidth = CONTENT_WIDTH }) {
  // Use mergedRakennusData if it exists and has keys, otherwise fallback to rakennusData
  const data = mergedRakennusData && Object.keys(mergedRakennusData).length > 0
    ? mergedRakennusData
    : rakennusData;
const cleanText = (value) => {
  if (!value) return value;

  return value
    .toString()
    .replace(/[\t\n\r]+/g, " ")  // remove tabs & line breaks
    .replace(/\s{2,}/g, " ")     // collapse multiple spaces
    .trim();
};
  console.log(data);

  const rakennukset = data?.rakennukset_fulls || [];

  console.log(mergedRakennusData)

  if (!rakennukset.length) {
    content.push({ text: "Ei kiinteistötietoja saatavilla.", style: "paragraph" });
    return;
  }

  const rak = rakennukset[0];
  const mainBuildings = rakennukset.filter(r => r.isMainBuilding);
  const firstMain = mainBuildings[0] || {};

  const sumField = (field) => mainBuildings.reduce((s, r) => s + (parseFloat(r[field]) || 0), 0);
  const sumKokonaisala = sumField("kokonaisala");
  const sumKerrosala = sumField("kerrosala");
  const sumHuoneistoala = sumField("huoneistoala");
  const sumTilavuus = sumField("tilavuus");

  // --- Kerrosluku
  const kerrokset = mainBuildings.map(r => r.kerroksia ?? 0);
  let sumKerroksia = "—";
  if (kerrokset.length) {
    const minK = Math.min(...kerrokset);
    const maxK = Math.max(...kerrokset);
    sumKerroksia = minK === maxK ? `${minK}` : `${minK}–${maxK}`;
    if (sumKerroksia === "0–0") sumKerroksia = "0";
  }

  // --- Kellarikerrokset — skip row entirely if no building has a real value
  const validKellarit = mainBuildings
    .map(r => r.kellarikerroksia)
    .filter(v => v != null && v !== '' && v !== 'Ei tiedossa' && Number(v) > 0)
    .map(Number);
  let sumKellarikerroksia = null; // null = omit the row
  if (validKellarit.length) {
    const minB = Math.min(...validKellarit);
    const maxB = Math.max(...validKellarit);
    sumKellarikerroksia = minB === maxB ? `${maxB}` : `${minB}–${maxB}`;
  }

  const allAddresses = rakennukset
    .map(r => r.osoite?.trim())
    .filter(Boolean)
    .filter((v, i, arr) => arr.indexOf(v) === i); // deduplicate

  // Rakennusluokitus can differ between main buildings (e.g. kerrostalo +
  // rivitalo on the same tontti) — list every distinct value, not just the first.
  const mainRakennusluokitukset = mainBuildings
    .map(r => r.rakennusluokitus?.trim())
    .filter(Boolean)
    .filter((v, i, arr) => arr.indexOf(v) === i);

  const infoSections = [
    {
      rows: [
        ["Kohteen nimi", data.kohteen_nimi || "—", data.metadata?.kohteen_nimi?.source || ""],
         ["Osoite", allAddresses.join(", ") || "—", rakennukset[0]?.metadata?.osoite?.source || ""],
        ["Toimipaikka", `${rak.postinumero || ""} ${rak.toimipaikka || ""}`.trim() || "—", rak.metadata?.toimipaikka?.source || ""],
      ],
    },
    {
      rows: [
        ["Kiinteistötunnus", (data.kiinteistotunnus || "—").replace(/\n/g, ", "), data.metadata?.kiinteistotunnus?.source || ""],
        ["Tontin koko", data.tontin_koko ? `${Math.round(data.tontin_koko)} m²` : "—", data.metadata?.tontin_koko?.source || ""],
        ["Tontin omistaja", data.tontin_omistaja || "—", data.metadata?.tontin_omistaja?.source || ""],
      ],
    },
    {
      rows: [
        ["Rakennusten lukumäärä", data.rakennusten_lkm || "—", data.metadata?.rakennusten_lkm?.source || ""],
        ["Ulkorakennusten lukumäärä", data.ulkorakennusten_lkm || "—", data.metadata?.ulkorakennusten_lkm?.source || ""],
        ["Huoneistojen lukumäärä", data.huoneistojen_lkm || "—", data.metadata?.huoneistojen_lkm?.source || ""],
        ["Rakennusluokitus", mainRakennusluokitukset.join(", ") || "—", firstMain.metadata?.rakennusluokitus?.source || ""],
      ],
    },
    {
      rows: [
        ["Rakennusvuosi", rak.rakennusvuosi || "—", rak.metadata?.rakennusvuosi?.source || ""],
        ["Peruskorjausvuosi", rak.peruskorjausvuosi || "—", rak.metadata?.peruskorjausvuosi?.source || ""],
        ["Laajennusvuosi", rak.laajennusvuosi || "—", rak.metadata?.laajennusvuosi?.source || ""],
      ],
    },
    {
      rows: [
        ["Kokonaisala", sumKokonaisala ? `${sumKokonaisala} m²` : "—", firstMain.metadata?.kokonaisala?.source || ""],
        ["Kerrosala", sumKerrosala ? `${sumKerrosala} m²` : "—", firstMain.metadata?.kerrosala?.source || ""],
        ["Huoneistoala", sumHuoneistoala ? `${sumHuoneistoala} m²` : "—", firstMain.metadata?.huoneistoala?.source || ""],
        ["Tilavuus", sumTilavuus ? `${sumTilavuus} m³` : "—", firstMain.metadata?.tilavuus?.source || ""],
        ["Kerroksia", sumKerroksia, firstMain.metadata?.kerroksia?.source || ""],
        ...(sumKellarikerroksia !== null ? [["Kellarikerroksia", sumKellarikerroksia, firstMain.metadata?.kellarikerroksia?.source || ""]] : []),
      ],
    },
  ];

  const noLinesLayout = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingTop: () => 0,
    paddingBottom: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 0,
  };

  infoSections.forEach((sec) => {
    const visibleRows = sec.rows.filter(([label, value]) => {
      const clean = (value ?? "").toString().trim();
      return clean && clean !== "—" && clean !== "-";
    });

    if (!visibleRows.length) return;

    const tableBody = visibleRows.map(([label, value, source]) => [
   { text: cleanText(label), style: "paragraph", margin: [0, 0, 0, 0], bold: true },
  { text: cleanText(value), style: "paragraph", margin: [0, 0, 0, 0], alignment: "left" },
      { text: normalizeSource(source) || "", style: "paragraph", italics: true, color: "#666", alignment: "right", margin: [0, 0, 0, 0] },
    ]);

    content.push({
      stack: [
        { text: sec.title, fontSize: 13, bold: true, margin: [0, 0, 0, 0] },
        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: contentWidth, y2: 0, lineWidth: 1.5, lineColor: "#198754" },
          ],
          margin: [0, 0, 0, bottomMarginItemGlobal],
        },
        { table: { widths: ["30%", "40%", "30%"], body: tableBody }, layout: noLinesLayout },
      ],
      unbreakable: true,
      margin: [0, 0, 0, bottomMarginItemGlobal],
    });
  });
}
